import { useTranslation } from '../../i18n/i18n';
import { Res, useApi } from '../../state/api';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { BonusOrdersTable } from './BonusOrdersTable';

export const BonusTable = (): JSX.Element => {
	const { data: bonusOrders, error } = useApi(Res.bonusOrders, {});
	const t = useTranslation().bonusPage;

	if (error) return <ErrorMessage />;

	return (
		<>
			<h2>{t.notYetActivated}</h2>
			<p>{t.bonusWillUpdate}</p>
			<BonusOrdersTable
				orders={(bonusOrders || [])
					.sort((a, b) => Number(Number(new Date(b.dateCreated)) - Number(new Date(a.dateCreated))))
					.filter((e) => !e.confirmed && new Date(e.dateExpires) > new Date())}
			/>
			<h2>{t.activatedBonus}</h2>
			<BonusOrdersTable
				orders={(bonusOrders || [])
					.sort((a, b) => Number(Number(new Date(b.dateCreated)) - Number(new Date(a.dateCreated))))
					.filter((e) => e.confirmed)}
			/>
		</>
	);
};
